

























































import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * Layout for the whole page
 */
@Component
export default class LayoutA extends Vue {
  /** Target for the logo link */
  @Prop({ type: String, default: "/" }) homeUrl!: string;

  menuActive: boolean = false;
}
